export default __webpack_public_path__ + "static/media/multiSignetSeal.6da52582.mp4";